var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevenueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 14.25H12.45C12.03 14.25 11.8199 14.25 11.6595 14.3317C11.5184 14.4037 11.4037 14.5184 11.3317 14.6595C11.25 14.8199 11.25 15.03 11.25 15.45V23.55C11.25 23.97 11.25 24.1801 11.3317 24.3405C11.4037 24.4816 11.5184 24.5964 11.6595 24.6683C11.8199 24.75 12.03 24.75 12.45 24.75H15.75M15.75 24.75H20.25M15.75 24.75L15.75 12.45C15.75 12.03 15.75 11.8199 15.8317 11.6595C15.9037 11.5184 16.0184 11.4037 16.1595 11.3317C16.3199 11.25 16.53 11.25 16.95 11.25L19.05 11.25C19.47 11.25 19.6801 11.25 19.8405 11.3317C19.9816 11.4037 20.0964 11.5184 20.1683 11.6595C20.25 11.8199 20.25 12.03 20.25 12.45V24.75M20.25 17.25H23.55C23.97 17.25 24.1801 17.25 24.3405 17.3317C24.4816 17.4037 24.5963 17.5184 24.6683 17.6595C24.75 17.8199 24.75 18.03 24.75 18.45V23.55C24.75 23.97 24.75 24.1801 24.6683 24.3405C24.5963 24.4816 24.4816 24.5964 24.3405 24.6683C24.1801 24.75 23.97 24.75 23.55 24.75H20.25",
    stroke: "#09041C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenueIcon);
export default __webpack_public_path__ + "static/media/revenue-icon.a5940b66e2e145bff62d8bcf12f6c02f.svg";
export { ForwardRef as ReactComponent };